import React from 'react';
import styles from './Toggle.module.scss';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  leftLabel?: string;
  rightLabel?: string;
  name?: string;
  id?: string;
}

const Toggle: React.FC<ToggleProps> = ({
  checked,
  onChange,
  disabled = false,
  leftLabel,
  rightLabel,
  name,
  id,
}) => {
  const toggleId = id || `toggle-${Math.random().toString(36).substr(2, 9)}`;

  const handleToggle = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      handleToggle();
    }
  };

  return (
    <div className={styles.toggleWrapper}>
      {leftLabel && (
        <span className={`${styles.toggleLabel} ${!checked ? styles.active : ''}`}>
          {leftLabel}
        </span>
      )}
      
      <div
        className={`${styles.toggleContainer} ${checked ? styles.checked : ''} ${disabled ? styles.disabled : ''}`}
        onClick={handleToggle}
        onKeyDown={handleKeyDown}
        tabIndex={disabled ? -1 : 0}
        role="switch"
        aria-checked={checked}
        aria-disabled={disabled}
      >
        <div className={styles.toggleThumb}></div>
      </div>

      {/* Hidden input for form submission */}
      <input
        type="checkbox"
        id={toggleId}
        name={name || toggleId}
        checked={checked}
        onChange={handleToggle}
        disabled={disabled}
        className={styles.toggleInputHidden}
        tabIndex={-1}
        aria-hidden="true"
      />

      {rightLabel && (
        <span className={`${styles.toggleLabel} ${checked ? styles.active : ''}`}>
          {rightLabel}
        </span>
      )}
    </div>
  );
};

export default Toggle;



